module.exports = __webpack_public_path__ + "img/eptv-g1.3052d720.png";